<div  style="width: 100%;" [formGroup]="group">
  <label class="radio-label-padding">{{field.label}}:</label>
  <mat-radio-group [ngStyle]="field.additionalOptions.radioGroupStyle" [formControlName]="field.name">
    <mat-radio-button [ngStyle]="field.additionalOptions.radioButtonStyle" *ngFor="let item of field.options" [value]="item.value">{{item.label}}</mat-radio-button>
  </mat-radio-group>
</div>

